module.exports = __webpack_public_path__ + "static/media/asset-based-create-work.6ca046e6.PNG";